orders-histories
  .expandable-wrap(class="{expanded: expanded}")
    .row.p-t-20.p-b-20(each="{histories}")
      .col-auto.text-right.update-meta
        .date(if="{date}")
          span {date}
          i.feather.icon-circle.bg-c-green
        .user(if="{user}")
          span {user}
          i.feather.icon-user.bg-c-green
      .col.update-values
        histories-show(each="{id in logs}" tag-scope="history_{id}")
  .expandable-over(class="{expanded: expanded}")
  .expandable-btn-wrap(class="{expanded: expanded}")
    span.btn.waves-effect.waves-light.btn-success.btn-outline-success(onClick="{onClickExpandableBtn}")
      i.feather.icon-chevrons-down
  script(type="typescript").
    this.mixin('histories.histories');
    this.mixin('shared.expandable');
    this.watch();
  style(scoped).
    :scope {
      display: block;
      position: relative;
    }
    :scope:after {
      content: "";
      position: absolute;
      background: #d6d6d6;
      height: 100%;
      width: 1px;
      top: 0;
      left: 148px;
      z-index: 1;
    }
    .update-meta {
      width: 200px;
      z-index: 2;
    }
    .icon-user,
    .icon-circle {
      border-radius: 50%;
      text-align: center;
      color: #fff;
    }
    .icon-user {
      width: 40px;
      height: 40px;
      font-size: 16px;
      padding: 12px 13px;
      margin-left: 10px;
    }
    .icon-circle {
      font-size: 8px;
      padding: 2px 2px;
      margin-left: 23px;
      margin-right: 14px;
    }
    .icon-circle:before {
      padding-left: 1px;
    }
    .date + .user {
      margin-top: 20px;
    }
    .date {
      padding-right: 0px;
    }
    .date span {
      font-size: 10px;
      color: #888;
    }
    @media (max-width: 575px){
      .update-meta {
        width: 100%;
      }
      :scope:after {
        left: auto;
        right: 20px;
      }
      .update-values {
        margin-right: 50px;
      }
      .date {
        text-align: left;
      }
    }
